import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Table,
  Typography,
} from "antd";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useData from "../../hooks/useData";
import extractName from "../../utils/extractName";
import SelectUser from "../SelectUser/SelectUser";
import { Trash } from "react-feather";
import { FaPencil } from "react-icons/fa6";
import Api from "../../Api";
import zipcelx from "zipcelx";
import { FaFileExcel } from "react-icons/fa";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  children,
  ...restProps
}) => {
  const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        <div
          style={{
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
            maxWidth: "500px",
            maxHeight: "200px",
            overflow: "auto",
            lineHeight: "1.4",
          }}
        >
          {children}
        </div>
      )}
    </td>
  );
};

const ExpensesTable = ({ record, onClose }) => {
  const { _id } = useAuthUser();
  const { data: users } = useData("/products/users");
  const {
    data: expenses,
    update,
    remove,
    isLoading,
    isMutating,
  } = useData(`/products/expenses?contractId=${record._id}`, []); // This is a custom hook that fetches data from the given URL
  const [editingKey, setEditingKey] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(isMutating);
  }, [isMutating]);

  const addExpense = async (values) => {
    return await Api.post("/analytics/order/update", {
      ...values,
      contractId: record._id,
    });
  };
  const isEditing = (record) => record._id === editingKey;

  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    form.resetFields();
    setModalVisible(false);
  };

  const edit = (record) => {
    setEditingKey(record._id);

    form1.setFieldsValue({
      ...record,
    });
  };

  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    try {
      const row = await form1.validateFields();
      await update({
        id: key,
        ...row,
        totalPrice: row.quantity * row.price,
      });
      setEditingKey("");
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const handleAddExpense = () => {
    form.validateFields().then(async (values) => {
      const newExpense = {
        contractId: record._id,
        name: values.name,
        quantity: values.quantity,
        price: values.price,
        totalPrice: values.quantity * values.price,
        author: _id,
      };
      await addExpense(newExpense);
      closeModal();
    });
  };

  const exportToExcel = () => {
    const exportColumns = columns.filter(
      (col) => col.key !== "actions" && col.key !== "author",
    ); // Фильтруем колонку "actions"
    const exportData = expenses?.map((expense, index) => {
      const rowData = [];
      exportColumns.forEach((col) => {
        let cellValue;
        let cellType = "string"; // По умолчанию тип - строка
        switch (col.dataIndex) {
          case "price":
          case "totalPrice":
            cellValue = expense[col.dataIndex]?.toFixed(2);
            cellType = "number";
            break;
          case "quantity":
            cellValue = expense[col.dataIndex];
            cellType = "number";
            break;
          case "author":
            cellValue =
              extractName(
                users?.find((user) => user._id === expense[col.dataIndex])
                  ?.name,
              ) || "";
            break;
          case "number": // Обрабатываем колонку "number"
            cellValue = index + 1;
            cellType = "number";
            break;
          default:
            cellValue = expense[col.dataIndex] || "";
        }
        rowData.push({ value: cellValue, type: cellType });
      });
      return rowData;
    });

    const config = {
      filename: `${record.id}-расход`, // Название файла
      sheet: {
        data: [
          exportColumns.map((col) => ({ value: col.title, type: "string" })), // Заголовки как объекты
          ...exportData,
        ],
      },
    };

    zipcelx(config);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "number",
      key: "number",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    { title: "Название", dataIndex: "name", key: "name", editable: true },
    {
      title: "Кол-во",
      dataIndex: "quantity",
      key: "quantity",
      inputType: "number",
      editable: true,
    },
    {
      title: "Стоимость",
      dataIndex: "price",
      key: "price",
      inputType: "number",
      render: (text) => `${text.toFixed(2)} ₾`,
      editable: true,
    },
    {
      title: "Всего",
      dataIndex: "totalPrice",
      key: "totalPrice",
      render: (text) => `${text.toFixed(2)} ₾`,
    },
    {
      title: "Автор",
      dataIndex: "author",
      key: "author",
      render: (text) => (
        <SelectUser
          selected={[text]}
          disabled={true}
          options={users
            ?.filter((user) => user._id === text)
            .map((team) => ({
              label: extractName(team.name),
              value: team._id,
            }))}
          onChange={() => {}}
        />
      ),
    },
    {
      title: "Действа",
      key: "actions",
      render: (text, record) => {
        const editable = isEditing(record);

        return (
          <>
            {editable ? (
              <span style={{ display: "flex" }}>
                <Typography.Link
                  onClick={() => save(record._id)}
                  style={{
                    marginInlineEnd: 8,
                  }}
                >
                  Сохранить
                </Typography.Link>
                <Popconfirm
                  title="Точно отменить?"
                  onConfirm={cancel}
                  okText={"Да"}
                  cancelText={"Нет"}
                >
                  <Typography.Link color={"#F00"}>Отмена</Typography.Link>
                </Popconfirm>
              </span>
            ) : (
              <span style={{ display: "flex" }}>
                <Button
                  shape={"round"}
                  danger
                  onClick={async () => await remove(record._id)}
                  icon={<Trash size={12} />}
                />
                <Button
                  type="link"
                  disabled={editingKey !== ""}
                  onClick={() => edit(record)}
                >
                  <FaPencil />
                </Button>
              </span>
            )}
          </>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType:
          col.dataIndex === "price" || col.dataIndex === "quantity"
            ? "number"
            : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Modal open={!!record} onCancel={onClose} width={1200} footer={false}>
      <Button
        type="primary"
        danger
        onClick={openModal}
        style={{ marginBottom: 16 }}
      >
        Добавить расход
      </Button>

      <Button
        danger
        onClick={exportToExcel}
        style={{ marginBottom: 16, marginLeft: 15 }}
        icon={<FaFileExcel size={12} />}
      >
        Экспорт в Excel
      </Button>

      <div className={"table-responsive"}>
        <Form form={form1} component={false}>
          <Table
            columns={mergedColumns}
            dataSource={expenses}
            loading={isLoading || isMutating}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            pagination={false}
            size={"small"}
          />
        </Form>
      </div>

      <Modal
        title="Добавить расход"
        open={modalVisible}
        onCancel={closeModal}
        onOk={handleAddExpense}
        okText="Добавить"
        cancelText="Отмена"
        okButtonProps={{
          disabled:
            form.getFieldsError().some((field) => field.errors.length) ||
            loading,
          loading: loading,
        }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Название"
            name="name"
            rules={[{ required: true, message: "Please enter product name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Количество"
            name="quantity"
            rules={[{ required: true, message: "Please enter quantity" }]}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label="Цена шт"
            name="price"
            rules={[{ required: true, message: "Please enter price" }]}
          >
            <InputNumber min={0} step={0.01} style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </Modal>
  );
};

export default ExpensesTable;
